exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reaction-button-wrap .reaction-button[data-v-399ef170] {\n  flex: 1;\n  margin-right: 0.5rem;\n}\n.reaction-button-wrap .reaction-count[data-v-399ef170] {\n  display: inline-block;\n  height: 1.5rem;\n  font-size: 1rem;\n  text-align: center;\n  border-radius: 999px;\n  color: #fff;\n  padding: 0 0.5rem;\n}", ""]);

// exports
